import * as styles from 'styles/pages/Styleguide.css'
import Anchor from 'components/atoms/navigation/Anchor'
import SGColors from 'components/utils/styleguide/SGColors'
import SGFonts from 'components/utils/styleguide/SGFonts'
import SGTextStyles from 'components/utils/styleguide/SGTextStyles'
import SGTextThemes from 'components/utils/styleguide/SGTextThemes'
import SGLogos from 'components/utils/styleguide/SGLogos'
import SGLayouts from 'components/utils/styleguide/SGLayouts'
import SGShadows from 'components/utils/styleguide/SGShadows'

const SGMeta = () => (
  <Anchor placement='meta'>

    <Anchor placement='meta_colors'>
      <h2 className={ styles.sgHeading }>Colors</h2>
      <SGColors />
    </Anchor>

    <Anchor placement='meta_themes'>
      <h2 className={ styles.sgHeading }>Themes</h2>
      <SGTextThemes />
    </Anchor>

    <Anchor placement='meta_shadows'>
      <h2 className={ styles.sgHeading }>Shadows</h2>
      <SGShadows />
    </Anchor>

    <Anchor placement='meta_fonts'>
      <h2 className={ styles.sgHeading }>Fonts</h2>
      <SGFonts />
    </Anchor>

    <Anchor placement='meta_text'>
      <h2 className={ styles.sgHeading }>Text Styles</h2>
      <SGTextStyles />
    </Anchor>

    <Anchor placement='meta_logos'>
      <h2 className={ styles.sgHeading }>Logos</h2>
      <SGLogos />
    </Anchor>

    <Anchor placement='meta_layouts'>
      <h2 className={ styles.sgHeading }>Layouts</h2>
      <SGLayouts />
    </Anchor>

  </Anchor>
)

export default SGMeta
